import initSelect2 from './select2.js';
import * as tooltip from './tooltip.js';

export const initForms = () => {
	//Remove disabled attribute from inputs before submiting them
	$('form').submit(function(e) {
	    $(':disabled').each(function(e) {
	        $(this).removeAttr('disabled');
	    })
	});

	/*
	 * Submit the form when clicking on the save button
	 * in this way does not check if there is an empty field that is required, and when returning back with the errors it shows the right tab (Done in PHP).
	 * Used when there is a form with different tabs
	 */
	$('[data-function="submit-form"]').click(function(e){
		e.preventDefault();
		$(this).parents('form').submit();
	});

	/*
	 * Removes the submitting of the form when pressing enter
	 * Used to prevent the auto submit of the scanner
	 */
	$('[data-submit-on-enter=false]').on("keypress", function(e) {
		if(e.keyCode == '13') {
			e.preventDefault();
		}
	});
}

// Save the current tab in the form so that it opens it again after saving
export const formWithTabs = (callback = function(){}) => {
	$('[role="tab"]').click(function(){
		$('[name="tab"]').val($(this).attr('href'));
	});

	$('[role="tab"]').on('shown.bs.tab', function (e) {
		callback();
	});
}

export const initDeleteBtn = () => {
	$('[data-function="delete-record"]').unbind('click.delete-record').bind('click.delete-record', function(){
		let url = $(this).data('url');
		$('#modal-delete .modal-title').html('');
		$('#modal-delete .modal-body').html(spinnerHtml());
		$('#modal-delete').modal();

		axios.get(url)
			.then(function (response) {
				$('#modal-delete .modal-content').html(response.data);
				$('#modal-delete input[name="_token"]').val($('meta[name="csrf-token"]').attr('content'));
			})
			.catch(function(error){
				$('#modal-delete .modal-content').html(
					`<div class="alert alert-danger mb-0" role="alert">
                    	Ein Fehler ist aufgetreten
                	</div>`);
			});
	});
}

// Format a number in this format +41 xx xxxx xx xx or this 0xx xxxx xx xx
export const initFormatPhoneNumber = () => {
	$('input[data-function="format-phone-number"]').unbind('keyup.data-format-phone-number').bind('keyup.data-format-phone-number', function function_name(argument) {
		let value = $(this).val();

		let phoneNumber = value.replace(/[^\d,+]/g, "");

		if(phoneNumber.slice(0, 2) == '00'){
			phoneNumber = `+${phoneNumber.slice(2)}`
		}

		if(phoneNumber.slice(0, 3) == '+41'){
			if(phoneNumber.slice(0, 1) == '+'){
				phoneNumber = `${phoneNumber.slice(0, 3)} ${phoneNumber.slice(3, 5)} ${phoneNumber.slice(5, 8)} ${phoneNumber.slice(8, 10)} ${phoneNumber.slice(10, 12)} ${phoneNumber.slice(12)}`;
			}else{
				phoneNumber = `${phoneNumber.slice(0, 3)} ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 8)} ${phoneNumber.slice(8, 10)} ${phoneNumber.slice(10)}`;
			}
		}else{
			if(phoneNumber.slice(0, 1) == '+'){
				phoneNumber = `${phoneNumber.slice(0, 3)} ${phoneNumber.slice(3, 5)} ${phoneNumber.slice(5, 9)} ${phoneNumber.slice(9)}`;
			}else{
				phoneNumber = `${phoneNumber.slice(0, 3)} ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 8)} ${phoneNumber.slice(8, 10)} ${phoneNumber.slice(10)}`;
			}
		}

        $(this).val(phoneNumber.trim());
	})
}

// Set a modal as ajax form
export const modalAjaxForm = (modal, callback = function(){}) => {
	var form = modal.find('form');
	form.on('submit',function(event){
		event.preventDefault();

		var url = $(this).prop('action');
		var data = $(this).serialize();

		$(this).find('[type="submit"]').hide();
		modal.find('#modal-spinner').removeClass('d-none');

		axios.post(url, data)
			.then(function (response) {
	     		modal.modal('hide');
				form.find('[type="submit"]').show();
				modal.find('#modal-spinner').addClass('d-none');

	            callback(response.data);
			});
	});
}

export const spinnerHtml = () => {
	return '<div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>';
}

export const formatNumber = (value, decimals = 2) => {
	return value.toFixed(decimals).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\'')
}

export const reverseFormat = (value) => {
	return parseFloat(value.toString().replace(/ /g,'').replace(/\'/g,''));
}

export const bmRoundPrice = (value) => {
	return Math.round(value * 20) / 20;
}

/*
 * Copy the prototype and add it to the form
 * after calls the function given
*/
export const addNewPrototype = (name, callback = function(){}, callbackOnDelete = function(){}) => {
	$('[data-function="'+name+'"]').unbind('click.add-new-prototype').bind('click.add-new-prototype', function(){
		var target = $(this).data('target');

		//Remove "no record" container
		$('[data-prototype-container="'+target+'"]').find('.no-records').remove();

		//Create unique id
		var uuid = parseInt(Math.random() * Math.floor(9899) + 100);

		var prototype = $('[data-prototype-name="'+target+'"]').data('prototype-html').replace(/__NAME__/g, uuid);

		$('[data-prototype-name="'+target+'"]').before(prototype);

		callback(uuid);
		removePrototype(callbackOnDelete);

		// Focus first input field
		let input = $('[data-prototype-name="'+target+'"]').prev().find('input[type="text"], select, textarea').eq(0);
		input.focus();
	});

	removePrototype(callbackOnDelete);
}

/*
 * Removes one prototype row
 * after calls the function given
*/
export const removePrototype = (callback = function(){}) => {
	$('[data-function="delete-prototype-row"]').unbind('click.delete-prototype-row').bind('click.delete-prototype-row', function(){
		var target = $(this).data('target');

		//Hide modal already open
		let openModals = $('.modal.show');
		openModals.modal('hide');

		if($(this).data('url')){
			//If it is saved in the database, call delete warnings and after delete the record via ajax
			let url = $(this).data('url');
			$('#modal-delete .modal-title').html('');
			$('#modal-delete .modal-body').html(spinnerHtml());
			$('#modal-delete').modal();
			axios.get(url)
				.then(function (response) {
					$('#modal-delete .modal-content').html(response.data);
					$('#modal-delete input[name="_token"]').val($('meta[name="csrf-token"]').attr('content'));

					//Set delete btn as ajax form
					modalAjaxForm(
						$('#modal-delete'),
						(data) => {
							if(data.success){
								$('[data-delete-target="'+target+'"]').remove();
								callback();
							}
						}
					);

				})
				.catch(function(error){
					$('#modal-delete .modal-content').html(
						`<div class="alert alert-danger mb-0" role="alert">
	                    	Ein Fehler ist aufgetreten
	                    	${error}
	                	</div>`);
				});
		}else{
			//If it is not saved in the database, delete it without ajax calls
			$('#modal-delete-general').modal();
			$('[data-function="delete-row"]').unbind('click').bind('click', function(){
				$('[data-delete-target="'+target+'"]').remove();
				$('#modal-delete-general').modal('hide');
				callback();
			});
		}

		//Show modal that were open before
		$('#modal-delete, #modal-delete-general').on('hide.bs.modal', function(){
			if(openModals){
				openModals.modal();
			}
			openModals = null;
		});
	});
}

//Links the date from and date to to the select
export const dateHandler = () => {
	// Change the from and to date when changing the select value
	$('[data-function="date-handler"]').unbind('change.date-handler').bind('change.date-handler', function(){
		let val = $(this).val();

		if(val == 'all'){
			$('#from').val('');
			$('#to').val('');
		}else if(val == 'today'){
			$('#from').val(moment().format('DD.MM.YYYY'));
			$('#to').val(moment().format('DD.MM.YYYY'));
		}else if(val == 'this month'){
			$('#from').val(moment().startOf('month').format('DD.MM.YYYY'));
			$('#to').val(moment().format('DD.MM.YYYY'));
		}else if(val == 'last month'){
			$('#from').val(moment().subtract(1,'months').startOf('month').format('DD.MM.YYYY'));
			$('#to').val(moment().subtract(1,'months').endOf('month').format('DD.MM.YYYY'));
		}else if(val == 'this year'){
			$('#from').val(moment().startOf('year').format('DD.MM.YYYY'));
			$('#to').val(moment().format('DD.MM.YYYY'));
		}else if(val == 'last year'){
			$('#from').val(moment().subtract(1,'years').startOf('year').format('DD.MM.YYYY'));
			$('#to').val(moment().subtract(1,'years').endOf('year').format('DD.MM.YYYY'));
		}

		if(val == 'user defined'){
			$('#from').attr('disabled', false);
			$('#to').attr('disabled', false);
		}else{
			$('#from').attr('disabled', true);
			$('#to').attr('disabled', true);
		}
	});
}

// Export excel when clicking on the button
export const exportExcelHandler = () => {
	$('[data-function="export-excel"]').unbind('click.export-excel').bind('click.export-excel', function(){
		let url = new URL($(this).data('url'));

		// Get address filter value and set it in the url
		let address = new URL(window.location.href);
		address = address.searchParams.get('address');
		if(address){
			url.searchParams.set('address', address);
		}

		// Get bootstrap search value and set it in the url
		let search = $('.bootstrap-table .search input').val();
		if(search){
			url.searchParams.set('search', search);
		}
		window.location.href = url.href;
	});
}

//Get address information and callback a function
export const getAddressInfo = (address_id, callback = function(){}) => {
	let url = '/api/address/' + address_id;
	if(Number.isInteger(parseInt(address_id))){
		$('html').addClass('cursor-progress');
		axios.get(url)
			.then(function (response) {
				// handle success
				callback(response.data);

				$('html').removeClass('cursor-progress');
			});
	}
}

//Get PRRC information and callback a function
export const getPrrcInfo = (value, callback = function(){}) => {
	let url = `/api/supplier/prrc/${value}`;

	$('html').addClass('cursor-progress');
	axios.get(url)
		.then(function (response) {
			// handle success
			callback(response.data);

			$('html').removeClass('cursor-progress');
		});
}

//Get PRRC information and callback a function
export const getUserInfo = (value, callback = function(){}) => {
	let url = `/api/user/${value}/get-info`;

	$('html').addClass('cursor-progress');
	axios.get(url)
		.then(function (response) {
			// handle success
			callback(response.data);

			$('html').removeClass('cursor-progress');
		});
}

export const filterHandler = () => {
	// Remove filter when clicking on the x
	$('[data-function="remove-filter"]').unbind('click.remove-filter').bind('click.remove-filter', function(){
		let filter = $(this).data('filter');

		var url = new URL(window.location.href);
		url.searchParams.delete(filter);
		window.location.href = url.href;
	});
}

// Add the different costs to the offer and order total
export const calcTotal = () => {
	let net_price = 0;
	$('[data-function="price-handler"]').each(function(){
		let price;
		let amount;

		if($(this).is('span')){
			price = reverseFormat($(this).html());
		}else{
			price = reverseFormat($(this).val());
		}

		if($(this).parents('.main-row').eq(0).find('[data-function="amount-handler"]').is('span')){
			amount = $(this).parents('.main-row').eq(0).find('[data-function="amount-handler"]').html();
		}else{
			amount = $(this).parents('.main-row').eq(0).find('[data-function="amount-handler"]').val();
		}

		if(amount == ''){
			amount = 1;
		}
		if(price != '' && !isNaN(price)){
			net_price += amount * price;
		}
	});

	if($('[data-id="shipping_price"]').length){
		let shipping_price;
		if($('[data-id="shipping_price"]').is('span')){
			shipping_price = reverseFormat($('[data-id="shipping_price"]').html());
		}else{
			shipping_price = reverseFormat($('[data-id="shipping_price"]').val());
		}

		let free_shipping_from = reverseFormat($('[data-id="free_shipping_from"]').val());

		if(!$('[data-id="free_shipping_from"]').val() || $('[data-id="free_shipping_from"]').val() == 0 || net_price < free_shipping_from){
			net_price += shipping_price;
		}
	}

	net_price = bmRoundPrice(net_price);

	$('[data-id="total-net"]').html(formatNumber(net_price));

	let vat = parseFloat($('#vat').val());
	let vat_price = (vat * net_price) / 100;
	vat_price = bmRoundPrice(vat_price);
	$('[data-id="total-vat"]').html(formatNumber(vat_price));

	let gross_price = net_price + vat_price;
	gross_price = bmRoundPrice(gross_price);
	$('[data-id="total-gross"]').html(formatNumber(gross_price));
}

/*
 * Handler of the address select
 */
export const addressHandler = (callback = function(){}) => {
	/*
	 * Fill the contact list after selecting an address
	 * Set the shipping method and the shipping price
	 * Add tooltip with the important customer info
	*/
	$('[data-function="address-handler"]').unbind('change.address-handler').bind('change.address-handler', function(){

		$('[data-function="tooltip-handler"]').addClass('d-none');
		$('[data-id="contacts"]').prop('disabled', false);

		let value = $(this).val();
		getAddressInfo(value, (data) => {
			pageVar.address = data;

			//Remove disable class from containers
			$('.disabled').removeClass('disabled');

			//Fill the contact list
			$('[data-id="contacts"]').prop('disabled', false);
			let contacts = [];
			contacts.push({id: '', text: "=== Ansprechperson auswählen ==="});
			data.contacts.forEach(contact => contacts.push({id: contact.id, text: contact.full_name}));
			updateOptionsSelect2($('[data-id="contacts"]'), contacts);

			//Set the shipping method and the shipping price
			$('[data-id="shipping_method_id"]').val(data.shipping_method_id)
			$('[data-id="shipping_price"]').val(data.shipping_price);
			$('[data-id="free_shipping_from"]').val(data.free_shipping_from);

			//Add tooltip with the important customer info
			if(data.important_remarks){
				tooltip.text('[data-function="tooltip-handler"]', data.important_remarks);
				tooltip.show('[data-function="tooltip-handler"]');
				tooltip.open('[data-function="tooltip-handler"]');
			}

			calcTotal();

			callback();
		});
	});
}

export const updateOptionsSelect2 = (el, options) => {
	// Check if select2 was already open and focused on
	let select2Open = el.parent().find('.select2-container.select2-container--open').length
	el.empty();
	initSelect2(el, options);

	// If select2 was focused at the start, then refocus pointer on it
	if(select2Open){
		el.select2("open");
	}
}

export const productPrototypeHandler = () => {
	/*
	 * Search for the possible price of the product
	 */
	$('[data-function="product-handler"]').unbind('change.product-handler').on('change.product-handler', function () {
		let parent = $(this).parents('.main-row').eq(0);
		let inputAmountSuggestion = $(this).parents('.main-row').eq(0).find('[data-function="amount-handler"]');
		let inputDiscountSuggestion = $(this).parents('.main-row').eq(0).find('[data-function="discount-handler"]');
		let inputPriceSuggestion = $(this).parents('.main-row').eq(0).find('[data-function="price-handler"]');
		let inputPriceTotal = $(this).parents('.main-row').eq(0).find('[data-function="price-total-handler"]');
		let imageProduct = $(this).parents('.main-row').eq(0).find('[data-id="image"]');
		let amountProduct = $(this).parents('.main-row').eq(0).find('[data-id="amount_available"]');
        let lockText = $(this).parents('.main-row').eq(0).find('[data-id="lock_text"]');

		let value = $(this).val();
		let address = $("#address_id").val();
		if(!Number.isInteger(parseInt(address)))
			address = 0;

		if( Number.isInteger(parseInt(value)) ){
			axios.get(
				'/api/product/' + value + '?address_id=' + address)
				.then(function (response) {
					if(response.data != ""){
						if(inputAmountSuggestion.val() == ""){
							inputAmountSuggestion.val(1);
						}

						imageProduct.attr('src', response.data.image);
						amountProduct.html(response.data.amount);
						amountProduct.removeClass('amount-available');
						amountProduct.removeClass('amount-not-available');
						if(response.data.amount > 0){
							amountProduct.addClass('amount-available');
						}else{
							amountProduct.addClass('amount-not-available');
						}

						inputDiscountSuggestion.val(response.data.discount);
						inputPriceSuggestion.val(formatNumber(response.data.discounted_price));
						inputPriceTotal.val(formatNumber(response.data.tarif_price));
                        lockText.html(response.data.lock_text);
                        
						calcTotal();
					}
				});
		}
	});

	//Change the discount or the price of the product when the price or discount is changed
	$('[data-function="discount-handler"], [data-function="price-handler"]').unbind('keyup.discount-price-handler').bind('keyup.discount-price-handler', function(e){
		let code = e.keyCode || e.which;

		// Exit function if the key that was pressed is the "Tab-Key"
		if([9, 16].includes(code)){
			return;
		}


		if($(this).data('function') == 'discount-handler'){
			let discount = $(this).val();
			let priceInput = $(this).parents('.main-row').eq(0).find('[data-function="price-handler"]');
			let tarifPrice = $(this).parents('.main-row').eq(0).find('[data-function="price-total-handler"]').val();
			tarifPrice = reverseFormat(tarifPrice);

			let price = tarifPrice - ((discount * tarifPrice) / 100);
			price = bmRoundPrice(price);
			if(!isNaN(price)){
				price = formatNumber(price);
				priceInput.val(price);
			}
		}else{
			let price = reverseFormat($(this).val());
			let tarifPrice = $(this).parents('.main-row').eq(0).find('[data-function="price-total-handler"]').val();
			tarifPrice = reverseFormat(tarifPrice);
			let discountInput = $(this).parents('.main-row').eq(0).find('[data-function="discount-handler"]');

			let discount = 100 - ((price * 100) / tarifPrice);
			if(!tarifPrice){
				discount = 0;
			}

			if(!isNaN(discount)){
				discount = Math.round(discount * 100) / 100;
				discountInput.val(discount);
			}
		}
		calcTotal();
	});

	// Whene the Total price is changed, trigger the discount price to calc the price again
	$('[data-function="price-total-handler"]').unbind('keyup.price-total-handler').bind('keyup.price-total-handler', function(){
		$(this).parents('.main-row').eq(0).find('[data-function="discount-handler"]').trigger('keyup');
	});
}
